"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _accordian = require("./accordian.style");
var _Icon = _interopRequireDefault(require("../Icon"));
function Accordian(_ref) {
  let {
    className = 'accordian',
    children,
    expanded = false,
    headerContent,
    item = {},
    index = 0,
    size = 'medium',
    fit = 'medium',
    variant = 'vanity',
    onCardToggle
  } = _ref;
  const OnAccoridanClick = (item, index) => {
    if (typeof onCardToggle === 'function') {
      onCardToggle(item, index);
    }
  };
  const headerType = typeof headerContent === 'string' ? 'button' : 'div';
  return (0, _jsxRuntime.jsxs)(_accordian.Components.Wrapper, (0, _extends2["default"])({
    variant: variant,
    className: className
  }, {
    children: [(0, _jsxRuntime.jsxs)(_accordian.Components.Header, (0, _extends2["default"])({
      className: "".concat(className, "-header"),
      type: "button",
      as: headerType,
      size: size === 'medium' ? fit : size,
      variant: variant,
      onClick: () => OnAccoridanClick(item, index)
    }, {
      children: [(0, _jsxRuntime.jsx)(_accordian.Components.HeaderLeftBlock, {
        children: (0, _jsxRuntime.jsx)(_accordian.Components.HeaderContent, {
          children: headerContent
        })
      }), (0, _jsxRuntime.jsx)(_accordian.Components.HeaderRightBlock, {
        children: (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: expanded ? 'chevron-up' : 'chevron-down'
        })
      })]
    })), expanded && (0, _jsxRuntime.jsx)(_accordian.Components.Body, (0, _extends2["default"])({
      className: "".concat(className, "-body"),
      "aria-expanded": expanded,
      size: size === 'medium' ? fit : size,
      variant: variant
    }, {
      children: children
    }))]
  }));
}
var _default = exports["default"] = Accordian;